import { render, staticRenderFns } from "./ArrowBack.vue?vue&type=template&id=31bfdfe8"
import script from "./ArrowBack.vue?vue&type=script&lang=js"
export * from "./ArrowBack.vue?vue&type=script&lang=js"
import style0 from "./ArrowBack.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports